import * as types from '../../actions/actiontypes';
import {normalize} from '../../util/utils';

export default function userReducer(state = null, action) {
	switch (action.type) {
		case types.GET_USER_BY_GUI: {
			return normalize([action.response], 'gui', state);
		}
		default:
			return state;
	}
}
